<template>
  <div ui-tree-handle="" folder-drop="afterDrop" class="kp-list-item">
    <div class="kp-folder-name kp-item-search">
      {{ account.name }}
      <p v-if="isRDDeprecated(account)" class="klick-deprecated-notify">
        {{ $t('account.list.deprecated') }}
      </p>
    </div>
    <div class="kp-folder-updatedate kp-item-search">
      {{ account.type }}
    </div>
    <div class="kp-folder-updatedate kp-item-search">
      {{ parsedDate(account.insert_date) }}
    </div>
    <a class="modallink kp-select-open"
       @click="modalOpen('delete-account');
       setActive(account);">
      <i class="icon-kp-delete"></i>{{ $t('account.actions.delete') }}
    </a>
    <a v-if="!isRDDeprecated(account)"
       class="modallink kp-select-open"
       @click="modalOpen('edit-account'); setActive(account);">
       <i class="icon-kp-edit"></i>{{ $t('account.actions.edit') }}
    </a>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import dateHelper from '../../../services/date';

export default {
  props: [
    'account',
  ],
  methods: {
    parsedDate(date) {
      return dateHelper(date);
    },
    isRDDeprecated(account) {
      const configIsObject = typeof account.config === 'object' && account.config !== null;
      const rdDeprecated = account.type === 'rdstation' && !configIsObject;

      return rdDeprecated;
    },
    ...mapActions({
      modalOpen: 'modal/open',
      setActive: 'account/setActive',
    }),
  },
};
</script>



// WEBPACK FOOTER //
// Item.vue?2731568c